export const PWA_UPDATE_EVENT = "htzap:pwa-update-ready";

function announceUpdate(registration: ServiceWorkerRegistration) {
  window.dispatchEvent(new CustomEvent(PWA_UPDATE_EVENT, { detail: { registration } }));
}

export function registerPwa() {
  if (import.meta.env.DEV || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .then((registration) => {
        if (registration.waiting) announceUpdate(registration);
        registration.addEventListener("updatefound", () => {
          const worker = registration.installing;
          if (!worker) return;
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) announceUpdate(registration);
          });
        });
        window.setInterval(() => void registration.update(), 60 * 60 * 1000);
      })
      .catch(() => undefined);
  });
}
